import * as vegaImport from 'vega';
export const vega: any = vegaImport;



// WEBPACK FOOTER //
// ./src/app/vega/shared/vega.ts